module.exports = __webpack_public_path__ + "static/media/moving-with-pickup_2x.66f5ff9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/moving-with-pickup_2x.png
// module id = 1180
// module chunks = 27